import React, { forwardRef } from 'react';

import { Box, type BoxProps } from '@atlaskit/primitives/compiled';

export type THeadProps = BoxProps<'thead'>;

/**
 * __THead__
 *
 * A primitive table head container. Applies the HTML native element with no styling.
 *
 * @primitive
 */
export const THead = forwardRef<HTMLTableSectionElement, THeadProps>(
	({ children, ...props }, ref) => {
		return (
			<Box as="thead" {...props} ref={ref}>
				{children}
			</Box>
		);
	},
);
